/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lab } from '../../models/lab';

export interface LabsViewCommnets$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  OBRID?: string | null;
}

export function labsViewCommnets(http: HttpClient, rootUrl: string, params?: LabsViewCommnets$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
  const rb = new RequestBuilder(rootUrl, labsViewCommnets.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('OBRID', params.OBRID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lab>;
    })
  );
}

labsViewCommnets.PATH = '/lab/comment';
